module.exports = __webpack_public_path__ + "static/img/check5.7eb9bacb.png";